<template>
  <div id="header" style="display: flex" :style="{background: bgTheme, top: statusBarHeaderTop}">
    <div class="header-wrapper text-light full-width">
      <div class="align-hor center-ver">
        <div><img class="medium-icon pull-left margin-10 pointer" src="@/assets/back-light.png" v-if="showBackButton" v-on:click="back"></div>
        <div class="text-left text-large" :class="[showBackButton ? 'padding-10' : 'padding-vertical-10']">{{getTranslatedText(headerTitle)}}</div>
      </div>
      <div class="tickets align-hor center-ver margin-right-10">
        <div v-if="showWallet" :class="[showHistory ? 'margin-right-30' : '']" v-on:click="enableWalletClick ? redirectTo('wallet', '') : ''">
          <div class="container">
            <img class="large-icon" src="@/assets/ticket-white.svg">
            <div class="text-small centered text-grey">{{totalUserPointsEarned}}</div>
          </div>
          <p class="text-uppercase text-semi-small no-margin" v-if="walletType">{{getTranslatedText(walletType)}}</p>
          <div class="wrapper" v-else>
            <div class="comment animate green text-uppercase text-semi-small no-margin" :style="`--bgcolor: ${bgTheme}`"></div>
          </div>
        </div>
        <div v-if="showHistory" v-on:click="redirectTo('history', '')">
          <img class="reward-icon" src="@/assets/history.svg">
        </div>
        <div v-if="userHeaderBalance.show && userHeaderBalance.balance > 0" class="credit align-ver center-ver">
          <div class="wrap padding-5 radius-30 bg-light align-hor center-ver center-hor">
            <img class="smaller-icon pull-left margin-right-5" :src="userHeaderBalance.icon">
            <span class="text-grey margin-right-5 align-hor center-ver">{{userHeaderBalance.balance}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { globals } from '@/mixins/globals'
  export default {
    name: 'custom-header',
    mixins: [globals],
    data() {
      return {
      }
    },
    methods: {
      redirectToHistory() {
        var path = "history"
        var params = {
          partner: self.partnerID, phone: self.userPhone
        };
        this.redirectTo(path, params);
      }
    }
  }
</script>

<style>
  #header {
    position: fixed;
    top: 0;
    display: block;
    left: 0;
    right: 0;
    z-index: 1;
    border-bottom: 1px solid #CCCCCC;
    height: 64px;
  }
  .header-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header-block {
    flex: 1;
  }
  .full-height {
    height: 100%;
  }
  .title {
    font-size: 18px;
  }
  .rewards {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .reward-icon {
    width: 40px;
  }
  .cash,
  .token,
  .rewards {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .rewards-count {
    bottom: 10px;
    left: 10px;
    padding: 2px;
    min-height: 25px;
    height: auto;
    min-width: 25px;
    width: auto;
  }
  .count {
    font-size: 12px;
  }
</style>


// WEBPACK FOOTER //
// src/components/header.vue